<template>
<vx-card :title="titulo">
    <div class="vx-col  w-full mb-base">
        <form enctype="multipart/form-data">
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Cédula</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" icon-no-border v-model="docente.cedula" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <input type="text" v-model="docente.idusuario" hidden>
                <input type="text" v-model="docente.id_group" hidden>
                <input type="text" v-model="docente.password" hidden>
                <input type="text" v-model="docente.fecha_create" hidden>
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Nombres</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input type="text" class="w-full" icon-pack="feather" icon-no-border v-model="docente.nombre" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Apellidos</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" icon-no-border v-model="docente.apellido" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Correo</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input type="email" class="w-full" icon-no-border v-model="docente.email" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Fecha nacimiento</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input type="date" :max="today" class="w-full" v-model="docente.f_nacimiento" @change="validateDate" />
                    <p v-if="dateError" style="color: red;">La fecha debe ser menor a la fecha actual.</p>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Teléfono</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input type="number" class="w-full" icon-no-border v-model="docente.telefono" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Genero</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <form>
                        <vs-radio class="m-2" v-model="docente.genero" vs-value="0">Hombre</vs-radio>
                        <vs-radio class="m-2" v-model="docente.genero" vs-value="1">Mujer</vs-radio>
                    </form>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Estado</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <form>
                        <vs-radio class="m-2" color="success" v-model="docente.estado" vs-value="1">Activo</vs-radio>
                        <vs-radio class="m-2" color="danger" v-model="docente.estado" vs-value="0">Inactivo</vs-radio>
                    </form>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Tipo de Usuario</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <v-select :options="grupo" :reduce="grupo => grupo.idgrupo" label="nombre" v-model="docente.id_group"></v-select>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Provincia</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <v-select v-if="tipo_edicion==0" class="formbold-form-input" @input="docente.institucion_idInstitucion = '';getInstitucionesxPronvincia()" :options="arregloProvincias" :reduce="arregloProvincias => arregloProvincias.id" label="provincia" v-model="registro.provincia"></v-select>
                    <v-select v-if="tipo_edicion==1" :options="arregloProvincias" label="provincia" v-model="provinciaSelect" @input="docente.institucion_idInstitucion = '';getInstitucionesxPronvincia()"></v-select>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Institución</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <v-select :options="arregloInstituciones" :reduce="arregloInstituciones => arregloInstituciones.idinstitucion" label="nombreInstitucion" v-model="docente.institucion_idInstitucion"></v-select>
                </div>
            </div>
            <div class="vx-col sm:w-1/2 w-full ml-auto">
                <vs-button color="success" type="border" @click="guardar(docente)" class="mb-2">{{ txt_btn }}</vs-button>
                <vs-button color="danger" type="border" class="mb-2 ml-2" @click="$router.go(-1)">Cancelar</vs-button>
            </div>
        </form>
    </div>
</vx-card>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import "vue-select/dist/vue-select.css";
import GeneralMixin from "@/mixins/GeneralMixin.js";
import vSelect from "vue-select";
Vue.use(axios)
Vue.component("v-select", vSelect);
export default {
    mixins: [GeneralMixin],
    data() {
        return {
            institucion: [],
            docente: {
                institucion_idInstitucion: '',
            },
            titulo: '',
            grupo: [],
            arregloProvincias: [],
            arregloInstituciones: [],
            txt_btn: '',
            registro: {
                provincia: '',
            },
            tipo_edicion: 0,
            institucionSelect: {},
            provinciaSelect: {},
            dateError: false,
        }
    },
    mounted() {
        this.grupos();
        this.getProvincias()
        // this.getPassword();
        if (!this.$route.params.id) {
            this.titulo = "Nuevo usuario";
            this.txt_btn = 'Guardar';
            this.tipo_edicion = 0;
        } else {
            this.titulo = "Editar usuario";
            this.txt_btn = 'Editar';
            this.getDocente(this.$route.params.id);
            this.tipo_edicion = 1;
        }
    },
    methods: {
        validateDate() {
            // console.log(this.datos.f_nacimiento)
            const currentDate = new Date();
            const selectedDate = new Date(this.datos.f_nacimiento);

            if (selectedDate >= currentDate) {
                this.dateError = true;
            } else {
                this.dateError = false;
            }
        },
        getProvincias() {
            let me = this;
            me.$http.get(this.$server_url + 'provincias')
                .then(function (res) {
                    me.arregloProvincias = res.data;
                })
                .catch(() => {});
        },
        grupos() {
            let me = this;
            me.$http.get(this.$server_url + 'grupo')
                .then(function (response) {
                    // console.log(response.data);
                    me.grupo = response.data;
                })
                .catch(() => {})
        },
        getPassword() {
            let me = this;
            me.$http.get(this.$server_url + 'password')
                .then(function (response) {
                    console.log(response.data);
                    me.docente.password = response.data;
                })
                .catch(() => {})
        },
        getInstitucionesxPronvincia() {
            let me = this;
            let id_busca_provincia = '';
            // me.docente.institucion_idInstitucion = ""
            me.arregloInstituciones = []
            if (me.tipo_edicion == 0) {
                if (me.registro.provincia == null || me.registro.provincia == "" || me.registro.provincia == undefined) {
                    me.f_notificaciones('Seleccione una provincia por favor', 'warning');
                    return
                }
                id_busca_provincia = me.registro.provincia;
            } else {
                id_busca_provincia = me.provinciaSelect.id;
            }
            me.$http.get(this.$server_url + 'getInstitucionesXProv/' + id_busca_provincia)
                .then(function (res) {
                    me.arregloInstituciones = res.data;
                    if (res.data.length == 0) {
                        me.f_notificaciones('No se encontro instituciones en la provincia', 'warning');
                    }
                })
                .catch(() => {});
        },
        getDocente(idusuario) {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'usuario/' + idusuario)
                .then(response => {
                    me.docente = response.data[0];
                    // console.log("uwu",me.docente);                   
                    me.provinciaSelect = {
                        'id': me.docente.id,
                        'provincia': me.docente.provincia
                    }
                    me.getInstitucionesxPronvincia();
                    me.$vs.loading.close();
                })
                .catch(() => {
                    me.$vs.loading.close();

                })
        },
        guardar(data) {
            let me = this;
            // console.log('me.$route.params.id=>', me.$route.params.id, 'docente instit', me.docente.institucion_idInstitucion)
            if (me.docente.cedula == null || me.docente.cedula == "" || me.docente.cedula == undefined) {
                me.f_notificaciones('Ingrese la cédula', 'warning');
                return;
            }
            if (me.docente.nombre == null || me.docente.nombre == "" || me.docente.nombre == undefined) {
                me.f_notificaciones('Ingrese el nombre', 'warning');
                return;
            }
            if (me.docente.apellido == null || me.docente.apellido == "" || me.docente.apellido == undefined) {
                me.f_notificaciones('Ingrese el apellido', 'warning');
                return;
            }
            if (me.docente.email == null || me.docente.email == "" || me.docente.email == undefined) {
                me.f_notificaciones('Ingrese el correo', 'warning');
                return;
            }
            if (me.docente.genero == null || me.docente.genero == "" || me.docente.genero == undefined) {
                me.f_notificaciones('Seleccione el género', 'warning');
                return;
            }
            if (me.docente.estado == null || me.docente.estado == "" || me.docente.estado == undefined) {
                me.f_notificaciones('Seleccione el estado', 'warning');
                return;
            }
            if (me.docente.id_group == null || me.docente.id_group == "" || me.docente.id_group == undefined) {
                me.f_notificaciones('Seleccione el perfil', 'warning');
                return;
            }
            if (me.docente.institucion_idInstitucion == null || me.docente.institucion_idInstitucion == "" || me.docente.institucion_idInstitucion == undefined) {
                me.f_notificaciones('Seleccione una institución', 'warning');
                return;
            }
            let id_user = 0;
            if (me.$route.params.id != undefined)
                id_user = me.$route.params.id;
            let formData = new FormData();
            formData.append('idusuario', id_user);
            formData.append('cedula', me.docente.cedula);
            formData.append('nombre', me.docente.nombre);
            formData.append('apellido', me.docente.apellido);
            formData.append('email', me.docente.email);
            formData.append('telefono', me.docente.telefono);
            formData.append('genero', me.docente.genero);
            formData.append('estado', me.docente.estado);
            formData.append('id_group', me.docente.id_group);
            formData.append('institucion_idInstitucion', me.docente.institucion_idInstitucion);
            me.$vs.loading();
            this.$http.post(this.$server_url + 'usuario', formData)
                .then(function (res) {
                    if (res.data.status == 0) {
                        me.f_notificaciones(res.data.message, 'danger');
                    } else {
                        me.f_notificaciones(res.data.message, 'success');
                        me.$router.go(-1);
                    }
                    me.$vs.loading.close();
                })
                .catch(() => {
                    me.f_notificaciones('No se guardó los datos, revise la información', 'danger');
                    me.$vs.loading.close();
                })
        }
    },
}
</script>
